import React from 'react'
import { Box } from 'grid-styled'
import formatDistance from 'date-fns/formatDistance'
import format from 'date-fns/format'
import parseJSONDate from 'date-fns/parseJSON'
// import { Icon } from 'components'

const DateFormat = Box.extend`
  display: inline-block;
`

const DateBox = ({ preText='Published', dateFormat, date, ...rest }) => (
  <DateFormat {...rest}>
    {/* <Icon color="inherit" name="calendar" /> */}
    { preText && `${preText} ` }
    {dateFormat
      ? format(parseJSONDate(date), dateFormat)
      : `${formatDistance(parseJSONDate(date), new Date())} ago`
    }
  </DateFormat>
)

export default DateBox



// WEBPACK FOOTER //
// /opt/build/repo/src/components/DateBox.js